"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("@emotion/react/jsx-runtime");
const b_1 = __importDefault(require("b_"));
const layout_1 = require("src/hooks/layout");
const tooltip_styles_1 = __importDefault(require("./tooltip.styles"));
const b = b_1.default.with('tooltip');
// eslint-disable-next-line complexity
function Tooltip({ children, text, widthType = 'narrow', widthTypeHover, widthTypeChecked, checked }) {
    const isNarrow = (0, layout_1.useIsMobile)();
    const resolvedWidthTypeHover = widthTypeHover || widthType;
    const resolvedWidthTypeChecked = widthTypeChecked || widthType;
    const shouldDisplayBase = text &&
        widthType !== 'none' &&
        (widthType === 'all' ||
            (isNarrow && widthType === 'narrow') ||
            (!isNarrow && widthType === 'wide'));
    const shouldDisplayOnHover = text &&
        resolvedWidthTypeHover !== 'none' &&
        (resolvedWidthTypeHover === 'all' ||
            (isNarrow && resolvedWidthTypeHover === 'narrow') ||
            (!isNarrow && resolvedWidthTypeHover === 'wide'));
    const shouldDisplayOnChecked = text &&
        checked &&
        resolvedWidthTypeChecked !== 'none' &&
        (resolvedWidthTypeChecked === 'all' ||
            (isNarrow && resolvedWidthTypeChecked === 'narrow') ||
            (!isNarrow && resolvedWidthTypeChecked === 'wide'));
    const shouldDisplay = shouldDisplayBase || shouldDisplayOnHover || shouldDisplayOnChecked;
    return ((0, jsx_runtime_1.jsx)("div", Object.assign({ css: tooltip_styles_1.default }, { children: (0, jsx_runtime_1.jsxs)("div", Object.assign({ className: b('wrapper', {
                showPopup: shouldDisplayOnChecked,
                hoverPopup: shouldDisplayOnHover,
                isNarrow
            }) }, { children: [children, shouldDisplay && (0, jsx_runtime_1.jsx)("div", Object.assign({ className: b('text') }, { children: text }))] })) })));
}
exports.default = Tooltip;
